import { Group } from '@qred/components-library';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { RootState } from '~/store';
import { useLoanOfferSelectors } from '~/store/selectors/loanOffer.selector';
import {
  setBeneficialOwners,
  updateForm,
} from '~/store/slices/loanOffer.slice';
import { isBeneficialOwner } from '~/helpers/shared.helper';
import AdditionalOwner from './AdditionalOwner';

const OwnersList = () => {
  const dispatch = useAppDispatch();
  const { owners, companyHasOtherBeneficialOwners } = useSelector(
    (state: RootState) => state.loanOffer.form
  );

  const {
    applicantIsABeneficialOwner,
    applicantIsSoloBeneficialOwner,
  } = useLoanOfferSelectors();

  useEffect(() => {
    if (owners.length) {
      const shouldResetOwnersList =
        (applicantIsABeneficialOwner && !companyHasOtherBeneficialOwners) ||
        applicantIsSoloBeneficialOwner;

      if (applicantIsSoloBeneficialOwner) {
        dispatch(
          updateForm({
            companyHasOtherBeneficialOwners: false,
          })
        );
      }

      if (shouldResetOwnersList) {
        dispatch(setBeneficialOwners([]));
      } else {
        dispatch(
          setBeneficialOwners(
            owners.filter((owner) =>
              companyHasOtherBeneficialOwners
                ? isBeneficialOwner(owner.percentage)
                : !isBeneficialOwner(owner.percentage)
            )
          )
        );
      }
    }
  }, [
    companyHasOtherBeneficialOwners,
    applicantIsABeneficialOwner,
    applicantIsSoloBeneficialOwner,
  ]);

  return (
    <Group mt="1em" mb="1em" direction="column" spacing="sm">
      {owners.map((owner) => (
        <AdditionalOwner owner={owner} key={owner.id} />
      ))}
    </Group>
  );
};

export default OwnersList;
